import { isStringNumber } from '@/utils/strings/strings';

const germanNumberFormatter = new Intl.NumberFormat('de-DE');

const germanCurrencyFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

const germanCurrencyFormatterWithoutFractions = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

/**
 * Formats a numerical money value to a mio currency string.
 * @example
 * formatMillions(1_000_000) // returns 1 Mio €
 * @param {Number} amount The money value
 * @returns {String} formatted value
 */
export const formatMillions = (amount: number): string =>
  `${germanNumberFormatter.format(amount / 1_000_000)} Mio €`;

/**
 * Formats a numerical money value to a currency string.
 * By default shows two decimals, which can be hidden with
 * the hideDecimals flag
 * @example
 * formatCurrency(1_000_000) // returns 1.000.000,00 €
 * @param {Number} amount The money value
 * @param {Boolean} hideDecimals Option to hide decimals
 * @returns {String} formatted value
 */
export const formatCurrency = (
  amount: number | string,
  hideDecimals = false,
): string => {
  let val = amount;

  if (typeof val === 'string') {
    if (isStringNumber(val)) {
      val = Number(val);
    } else {
      return val;
    }
  }

  if (val >= 999999999) {
    return 'unbegrenzt';
  }

  if (hideDecimals) {
    return germanCurrencyFormatterWithoutFractions.format(val);
  }

  return germanCurrencyFormatter.format(val);
};
